import { Module } from 'vuex-smart-module';
import MaterialsActions from './actions';
import MaterialsGetters from './getters';
import MaterialsMutations from './mutations';
import MaterialsState from './state';

export default new Module({
  state: MaterialsState,
  mutations: MaterialsMutations,
  actions: MaterialsActions,
  getters: MaterialsGetters,
});
